import {createFileRoute} from "@tanstack/react-router";

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS, ROLES} from "@/lib/auth/roles";
import FirmProfile from "@/modules/profile";
import { PROFILE_PATH, PROFILE_URL } from "@/utils/urls";

export const Route = createFileRoute(PROFILE_PATH)({
  component: FirmComponent,
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Reputation', path: '#'},
        {label: 'Public firm profile', path: PROFILE_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  },
})

function FirmComponent() {
  return (
    <>
      <Authorisation
        roles={[ROLES.ROLE_VIEW_FIRM]}
        permissions={[PERMISSIONS.IS_FIRM_VIEW_ON_FIRM_OR_NETWORK]}
        forbiddenFallback={<Unauthorized/>}
      >
        <div className={'flex flex-col items-left justify-center'}>
          <FirmProfile/>
        </div>
      </Authorisation>
    </>
  )
}